import type { ReactNode } from "react";
import classNames from "classnames";

interface WrapperBlogProps {
    children: ReactNode;
    className?: string;
}

// Narrower page container used by the blog
const WrapperBlog = ({ children, className }: WrapperBlogProps) => {
    return (
        <div
            className={classNames(
                "md:pr-4 md:pl-4 max-w-screen w-full mx-auto xl:pr-24 xl:pl-24 pt-2 pb-2",
                className
            )}
        >
            {children}
        </div>
    );
};

export default WrapperBlog;